export default __webpack_public_path__ + "static/media/element_1.a25d2512.webp";